import { formatDateDDMMYY, handlePreventDefault } from '@helper/utils';
import { useDebounce } from '@hooks/useDebounce';
import { ReactElement } from 'react';
import { IBankingHistoryFilter } from '.';
import { MultiDateRangePicker } from '@components/common';
import { NavLink } from 'react-router-dom';
import Checkbox from '@components/common/formControl/checkbox/checkbox';

export const BankingHistoryFilter = (props: IBankingHistoryFilter): ReactElement => {
	const { setSearch, date, setDate, records, isFnbUsers, setIsFnbUsers, fbk_membership_no } = props;
	const handleSearch = useDebounce((e: React.ChangeEvent<HTMLInputElement>): void => {
		e.preventDefault();
		setSearch(e?.target?.value);
	}, 1000);

	const dateRangeText =
		Array.isArray(date) && date.length === 2 && date[0] instanceof Date && date[1] instanceof Date
			? `${formatDateDDMMYY(date[0])} to ${formatDateDDMMYY(date[1])}`
			: '';

	return (
		<div className="filter-section history-filter">
			<div className="container">
				<div className="search-filter-wrapper">
					<div className="search-with-filter">
						<div className="search">
							<form onSubmit={handlePreventDefault}>
								<div className="search-row">
									<div className="input-col">
										<label htmlFor="search-top" className="hide">
											search
										</label>
										<input
											type="text"
											name="search"
											id="search-top"
											placeholder="Search Coupon / Supervisor Name / Mobile number"
											className="search-bar"
											autoComplete="off"
											onChange={handleSearch}
										/>
									</div>

									<button className="search-button" aria-label="search user">
										<span className="icon-search"></span>
									</button>
								</div>
							</form>
						</div>
					</div>

					<MultiDateRangePicker name="date" value={date} onChange={setDate} />
					{setIsFnbUsers != null && fbk_membership_no != null && (
						<div className="fnb-user-filter">
							<Checkbox
								id="is_fnb_users"
								name="is_fnb_users"
								type="checkbox"
								checked={isFnbUsers ?? false}
								onChange={() => setIsFnbUsers(!isFnbUsers)}
								label={`Show points for FNB ${fbk_membership_no ?? '-'}`}
							/>
						</div>
					)}

					{records && records.length !== 0 && (
						<p className="show-entries">
							Showing 1 to {records.length} of {records.count} entries
						</p>
					)}
					{dateRangeText && (
						<div className="filter-tags show">
							<ul className="tag-list">
								<li>
									{dateRangeText}
									<NavLink
										to="#"
										aria-label="disable tag"
										onClick={(e) => {
											e.preventDefault();
											setDate([null, null]);
										}}
									>
										<span className="icon-cross"></span>
									</NavLink>
								</li>
							</ul>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
